import React from "react";
import { Star } from "lucide-react";
import { useContent } from "../../ContentContext";

const DEFAULTS = {
    kicker: "Locally Loved",
    heading_line_1: "Loved By",
    heading_line_2: "Collingwood",
    heading_line_3: "Locals",
    rating: "4.9",
    rating_label: "Google Rating",
    items: [
        { rating: 5, text: "Best poutine in Collingwood. Fantastic little food truck, ideal location directly behind Treetz Cannabis. The fries were perfectly crispy and the gravy with fresh dill was unreal." },
        { rating: 5, text: "Delicious sandwiches, the flavours went so well together. My husband got the brisket smash burger and I got the crispy chicken crunch. Fries were unreal and the owner was incredibly welcoming and friendly." },
        { rating: 5, text: "My boyfriend kept raving about this place and now I understand why. I ordered the crispy chicken sandwich after skiing and it was incredible. Everything tasted fresh and homemade." },
        { rating: 5, text: "Very welcoming and friendly chefs, short wait time and absolutely delicious sandwiches. We had the crispy chicken and the Brisket Philly and both were packed with flavour." },
        { rating: 5, text: "Amazing food and great variety. The best part is the open seating, pet friendly atmosphere and lots of parking. Such a cool local food truck experience." },
        { rating: 5, text: "Absolutely amazing. We got the pesto sandwich and the lobster roll and both were so good. Hidden little food truck that punches way above its weight." },
        { rating: 5, text: "What a great recommendation. The Brisket Philly Cheesesteak did not disappoint at all. Plenty of meat, crispy onions, fresh dill and amazing flavour." },
        { rating: 5, text: "Picked up lunch from here today and everything was excellent. The brisket smash burger and Cubano were both full of flavour and the fries were delicious too." },
    ],
};

const ReviewCard = ({ r, i }) => (
    <div
        data-testid={`review-card-${i}`}
        className="min-w-[300px] sm:min-w-[340px] max-w-[300px] sm:max-w-[340px] snap-start bg-[#FAF7F0] rounded-[6px] p-6 sm:p-7 border border-[#1A1A1A]/8 shadow-[0_8px_30px_-12px_rgba(26,20,16,0.18)] flex flex-col gap-4 grain"
    >
        <div className="flex gap-1">
            {Array.from({ length: 5 }).map((_, k) => (
                <Star
                    key={k}
                    size={14}
                    fill={k < r.rating ? "#C65A2C" : "transparent"}
                    strokeWidth={1.5}
                    className={k < r.rating ? "text-[#C65A2C]" : "text-gray-300"}
                />
            ))}
        </div>

        <p className="font-display text-[16px] sm:text-[17px] leading-[1.45] tracking-[-0.005em] text-[#1A1A1A] normal-case">
            "{r.text}"
        </p>
    </div>
);

export const Reviews = () => {
    const { content } = useContent();
    const r = content?.reviews || {};
    const reviews = (r.items && r.items.length > 0) ? r.items : DEFAULTS.items;
    const kicker = r.kicker || DEFAULTS.kicker;
    const h1 = r.heading_line_1 || DEFAULTS.heading_line_1;
    const h2 = r.heading_line_2 || DEFAULTS.heading_line_2;
    const h3 = r.heading_line_3 || DEFAULTS.heading_line_3;
    const rating = r.rating || DEFAULTS.rating;
    const ratingLabel = r.rating_label || DEFAULTS.rating_label;
    return (
        <section
            data-testid="reviews-section"
            className="py-12 bg-[#EFE7DB] overflow-hidden grain"
        >
            <div className="px-6 mb-10">
                <div className="flex items-center gap-3 mb-4">
                    <div className="h-[2px] w-8 bg-[#C65A2C]" />
                    <div className="font-body text-[10px] uppercase tracking-[0.45em] font-semibold text-[#C65A2C]">
                        {kicker}
                    </div>
                </div>

                <h2 className="font-display text-5xl sm:text-6xl uppercase font-bold leading-[0.95] tracking-tight text-[#1A1A1A]">
                    {h1}
                    <br />
                    <span className="italic font-normal">{h2}</span>
                    <br />
                    {h3} <span className="text-[#C65A2C]">❤</span>
                </h2>

                <div className="mt-6 flex items-center gap-3">
                    <div className="flex gap-0.5">
                        {Array.from({ length: 5 }).map((_, i) => (
                            <Star key={i} size={18} fill="#C65A2C" strokeWidth={1.5} className="text-[#C65A2C]" />
                        ))}
                    </div>
                    <div className="font-display text-2xl font-bold text-[#1A1A1A]">{rating}</div>
                    <div className="text-[10px] uppercase tracking-[0.25em] text-gray-600 font-semibold font-body">
                        {ratingLabel}
                    </div>
                </div>
            </div>

            <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pl-6 pr-6 pb-6 no-scrollbar scroll-smooth">
                {reviews.map((rev, i) => (
                    <ReviewCard key={i} r={{ text: rev.text, rating: rev.stars || rev.rating || 5 }} i={i} />
                ))}
            </div>

            <div className="px-6 pt-2 flex items-center gap-2">
                <div className="flex-grow h-px bg-[#1A1A1A]/15" />
            </div>
        </section>
    );
};
